module.exports = __webpack_public_path__ + "static/media/carroussel_11.b7d71814.jpg";